/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".resultContent_33cbf444{display:table-row}.resultContent_33cbf444 .resultItem_33cbf444{display:table-cell;vertical-align:bottom}.peoplePickerPersona_33cbf444{width:180px}.peoplePickerPersona_33cbf444 .ms-Persona-details{width:100%}.peoplePicker_33cbf444 .ms-BasePicker-text{min-height:40px}.peoplePickerPersonaContent_33cbf444{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:7px 12px}\n" }]);
export var resultContent = "resultContent_33cbf444";
export var resultItem = "resultItem_33cbf444";
export var peoplePickerPersona = "peoplePickerPersona_33cbf444";
export var peoplePicker = "peoplePicker_33cbf444";
export var peoplePickerPersonaContent = "peoplePickerPersonaContent_33cbf444";
//# sourceMappingURL=PeoplePicker.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/pickers/PeoplePicker/PeoplePicker.scss.js
// module id = 333
// module chunks = 0